import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import { DEFAULT_DIALING_CODE } from "../../../../../constants/Constants";
import {
  INPUTS_PROPS,
  ADD_PARKING_ALLOCATION_STEPS,
  ADD_ALLOCATIONS_FORM_STEPS
} from "../../../../../enums/Enums";
import { Button } from "@mui/material";
import Strings from "../../../../../resources/Strings";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import store from "../../../../../redux/Store";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import { getSiteFromSiteId } from "../../../../../utils/UsersUtils";
import Icons from "../../../../../resources/icons/Icons";
import UserTypeStep from "../../../Forms/Wizard Forms/Steps/UserTypeStep";
import {
  showErrorMessage,
  showUpdateSuccessMessage,
  showParkingAllocationSaveIsNotReadyMessage
} from "../../../../../utils/MessagesUtils";
import { getAddedParkerToAllocationModel } from "../../../../../utils/AllocationUtils";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { allocationsActions } from "../../../../../redux/reducers/AllocationsReducer";
import classes from "../WizardForm.module.css";
import { CarUserTokenOperationsEntity } from "../../../../../entities/ServicesEntities/UserEntities/CarUserTokenOperationsEntity";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import * as carUserTokenActionsService from "../../../../../services/ActionsService/CarUserTokenActionsService";
import AssignAllocationStep from "../Steps/AssignAllocationStep";


const AddAllocationsForm = (props) => {
  const firstStep = ADD_PARKING_ALLOCATION_STEPS.USER_TYPE;
  const parkers = useSelector((state) => state.user.parkers);
  const scopesIds = useSelector((state) => state.user.currentUsersScopes).map(userScope => userScope.id);
  const sites = useSelector((state) => state.user.sites);
  const userTypes = useSelector((state) => state.user?.initialState?.userTypes);

  const showExsistingParkingAllocation = useSelector(
    (state) => state.common.showExsistingParkingAllocation
  );
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  // const [selectedSites, setSelectedSites] = useState(
  //   props.userData?.utronUser?.userSites?.map((us) => us.site)
  // );
  const selectedSites = useSelector((state) => {
    return state.user?.selectedSites;
  });

  // const [selectedSites, setSelectedSites] = useState(
  //   selectedParker.utronUser?.userSites?.map((us) => us.site)
  // );
  
  const [isFobSkipped, setIsFobSkipped] = useState(false); // added
  const assigneOption = useSelector((state) => state.common.assigneOption);

  const [isAddParkingAllocationInProcess, setIsAddParkingAllocationInProcess] = useState(false); // on process and on cancel
  const [isShowSaveChanges, setIsShowSaveChanges] = useState(false);

  const AssignAllocationStepRef = useRef();

  const [formData, setFormData] = useState({
    dialingCode: DEFAULT_DIALING_CODE,
    token: "",
    fob: "",
    userType: "",
    isPaying: false,
    tokens: [],
    carUserTokens: [],
    // carUserTokens: props?.userData?.carUserTokens?.map((carToken) => {
    //   return {
    //     occupiedToken: carToken,
    //     fob: carToken?.carUserTokens.filter(
    //       (carUserToken) =>
    //         carUserToken?.userId === props?.userData?.utronUser?.id
    //     )[0]?.fob,
    //   };
    // }),
    isStepSubmitted: false,
    //selectedSite: selectedSites?.length > 0 ? selectedSites[0] : 0,
    site: selectedSites?.length > 0 ? selectedSites[0]?.id : 0,
    selectedSites: selectedSites,
    
    // allocation
    selectedParker: null, 
    assignedParkers: [],
    foundedExistingParker: null // for existing usage
    //isCompleted: false,
  });

  // const [stateData, setStateData] = useState({
  //   currentStep: ADD_PARKING_ALLOCATION_STEPS.USER_TYPE,
  //   totalSteps: 3,
  //   isCurrentStepValid: false,
  // });

  useEffect(() => {
    return () => {
      // unmount - on close reset assignOption - case site with fob
      store.dispatch(commonActions.setShowScanFobButton(true));
      store.dispatch(commonActions.setShowFobScannerInput(false));
      store.dispatch(commonActions.setShowAssigneFobOptions(false));
      store.dispatch(commonActions.setAssigneOption(null));
      store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
      store.dispatch(commonActions.setShowAddNewUserButton(false)); // allocation add
    }
  }, []);

  const [stateData, setStateData] = useState({
    currentStep: ADD_ALLOCATIONS_FORM_STEPS.USER_TYPE,
    totalSteps: 4,
    isCurrentStepValid: false,
  });

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };

  const getStepsHeaders = () => {
    let stepHeader = null; // when stepHeader = null, no stepHeaders to reopen (used for closing modal on the submit)
    if (stateData.currentStep === ADD_ALLOCATIONS_FORM_STEPS.USER_TYPE) {
      stepHeader = new StepHeaderEntity(
        Strings.STEPS_TITLES.USER_TYPE_MODAL_ADD_ALLOCATION_TITLE,
        null, //Strings.STEPS_TITLES.USER_TYPE_MODAL_ADD_ALLOCATION_SUB_TITLE,
        Icons.NEW_PARKER,
        null
      );
    }
    if (stateData.currentStep === ADD_ALLOCATIONS_FORM_STEPS.SEARCH_PARKER) {
      stepHeader = new StepHeaderEntity(
        Strings.STEPS_TITLES.ADD_ALLOCATION_TITLE,
        null,
        Icons.ALLOCATION,
        null
      );
    } else if (
      stateData.currentStep === ADD_PARKING_ALLOCATION_STEPS.ADD_TOKENS
    ) {
      stepHeader = new StepHeaderEntity(
        Strings.STEPS_TITLES.ADD_TOKEN_MODAL_ADD_ALLOCATION_TITLE,
        Strings.STEPS_TITLES.ADD_TOKEN_MODAL_ADD_ALLOCATION_SUB_TITLE,
        Icons.CAR2,
        null
      );
    }

    return stepHeader;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // const oldAssignedAllocationsIds = props?.userData?.carUserTokens?.map(
    //   (carUserToken) => carUserToken?.id
    // );

    // checks only on the first assigned parker
    // const oldAssignedAllocationsIds = formData.assignedParkers[0].utronUser.carUserTokens?.map(
    //   (carUserToken) => carUserToken?.id
    // );

    // get old carUserToken Ids for each assignedParkers -- used for existing case
    const oldAssignedAllocationsIds = formData.assignedParkers.map(parker => parker.utronUser.carUserTokens).flat().map(cut => cut.id);

    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const { assignedParkers, site, carUserTokens } = formData; // check to map assignedParkers.carUserTokens as the carUserTokens to send

    if (stateData.isCurrentStepValid) {
      const carUserTokenOperationsEntity = new CarUserTokenOperationsEntity(
        assignedParkers[0].utronUser.id, //sets the associated carUserToken to the first parker on list//props?.userData?.utronUser?.id,
        site,
        assignedParkers[0].utronUser.userToUserTypes?.find(
          (type) => type?.userType?.siteId === site
        )?.userType?.id,
        assignedParkers.map(parker => parker.carUserTokens).flat().filter(
            (carUserToken) =>
              !oldAssignedAllocationsIds?.includes(carUserToken?.token?.id)
        )
      );

      carUserTokenActionsService
        .assignCommonCarUserTokens(carUserTokenOperationsEntity, true, false)
        .then((response) => {
          if (response.data.isSuccess) {
            // prevents the sideModal to be reopened
            // (see: UserTypeStep, useEffect props.currentStep)
            stateData.currentStep++; 
            store.dispatch(commonActions.closeSideModal());

            // build from createdToken the allocationModel
            let carUserTokenData = {fob: !formData.selectedSites[0].isFobsSupported ? null : assignedParkers[0].carUserTokens[0].fob /*response.data.entity[0].fob*/, isActive: true, isOccupied: false, carId: null};
            let firstAssignedParker = parkers.find(parker => parker.utronUser.id === assignedParkers[0]?.utronUser?.id);
            let allocationSelectionModel = getAddedParkerToAllocationModel(firstAssignedParker, response.data.entity[0], carUserTokenData, sites, userTypes);

            let parkersIds = parkers.map(parker => parker.utronUser.id);
            actionsService.getUsersMinimalIdentityData(parkersIds, scopesIds, selectedScope, true, true)
            .then((response) => {
              store.dispatch(allocationsActions.setAllocations({parkers: response.data.entity, sites, userTypes}));
              store.dispatch(allocationsActions.setAllocationSelectionModel(allocationSelectionModel));
              store.dispatch(userActions.setShowUserInfoWindow(true));
              showUpdateSuccessMessage();
            });

              // actionsService
              //   .getUserSites(true, false)
              //   .then((response) => {
              //     store.dispatch(userActions.setSites(response.data.entity));
              //     showUpdateSuccessMessage();
              //   })   

              // .then(() => {
              //   store.dispatch(userActions.setUsersScope(selectedScope.id));
              //   showUpdateSuccessMessage();
              // });
              // .then(() => {
              //   console.log(response.data.entity);
              //   //console.log(allocations);
              //   change to check by tokenId, response.data.entity[0].token.id
              //   // auto open info window and show results of the created allocation 
              //   let createdAllocationSelectionModel = allocations.find(allocation => allocation.userId === response.data.entity[0]?.userId);
              //   store.dispatch(allocationsActions.setAllocationSelectionModel(createdAllocationSelectionModel));
              //   store.dispatch(userActions.setShowUserInfoWindow(true));
              // });
              //store.dispatch(userActions.setParkersAndGuests());
          } else {
            showErrorMessage(response.data?.error);
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          }
        })
        .catch(error => {
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            showErrorMessage(error);
        });
    }
  };

  const next = () => {
    if (stateData.isCurrentStepValid) {
      let currentStep = stateData.currentStep;
      currentStep =
        currentStep >= stateData.totalSteps - 1
          ? stateData.totalSteps
          : currentStep + 1;
      setStateData({ ...stateData, currentStep: currentStep });
      setFormData({ ...formData, ["isStepSubmitted"]: false });
  
      // check if selected site is fob-supported
      let selectedSite = selectedSites.find(site => site.id === formData.site);
      if (!selectedSite?.isFobsSupported) {
        setIsFobSkipped(true);
      }
      else {
        setIsFobSkipped(false);
      }
    }
  };

  const prev = () => {
    let currentStep = stateData.currentStep;
    if (formData.assignedParkers?.length === 0 && formData.selectedParker === null) {
      currentStep =
        currentStep <= stateData.totalSteps ? currentStep - 1 : currentStep;
      setStateData({ ...stateData, currentStep: currentStep });
      setFormData({ ...formData, ["isStepSubmitted"]: false });
    }

    // Reset to initial state, clear all data
    // todo: clear fob
    store.dispatch(commonActions.setShowScanFobButton(true));
    store.dispatch(commonActions.setShowFobScannerInput(false));
    store.dispatch(commonActions.setShowAssigneFobOptions(false));
    store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
    store.dispatch(commonActions.setShowAddNewUserButton(false)); // allocation add
    
    // added - when clicking back in all cases clear selection
    store.dispatch(commonActions.setAssigneOption(null));
    setFormData(
      { ...formData, 
        ["selectedParker"] : null,
        ["foundedExistingParker"] : null,
        ["assignedParkers"] : [],
        [INPUTS_PROPS.CAR_USER_TOKEN]: [], 
        [INPUTS_PROPS.TOKENS]: [], 
        [INPUTS_PROPS.FOB] : "", // temporary - for fob supported site - new parking
        //[INPUTS_PROPS.FOB]: removeFob ? "" : formData.fob, 
        ["isStepSubmitted"]: false 
      });   // added 

    AssignAllocationStepRef.current.setOccupiedTokens([]);
  };

  return (
    <>
      {stateData.currentStep !== firstStep && (
        <div className={classes.prev}>
          <img src={Icons.LEFT_ARROW} />
          <Button onClick={prev}>Back</Button>
        </div>
      )}
      <div className={classes.formContainer}>
        <form name="AddAllocationsForm" onSubmit={handleSubmit}>
          <UserTypeStep
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            stepHeader={getStepsHeaders()}
            {...formData}
          />
          {/* represent the modified AddTokensWithFobStep*/}
          <AssignAllocationStep
            currentStep={stateData.currentStep}
            handleChange={handleChange}
            handleCurrentStepValidity={handleCurrentStepValidity}
            userTypeId={formData.userType}
            selectedSite={getSiteFromSiteId(selectedSites, formData.site)}
            setIsShowSaveChanges={setIsShowSaveChanges}
            isFobSkipped={isFobSkipped}
            setIsFobSkipped={setIsFobSkipped}
            ref={AssignAllocationStepRef} // added
            setIsAddParkingAllocationInProcess={setIsAddParkingAllocationInProcess}
            stepHeader={getStepsHeaders()}
            {...formData}
          ></AssignAllocationStep>

          {stateData.currentStep < stateData.totalSteps &&
            stateData.currentStep <= 2 &&
            !showExsistingParkingAllocation && (
              <div className={classes.next}>
                <EllipseButton onClick={next}>{Strings.NEXT}</EllipseButton>
              </div>
            )}
          {/* {stateData.currentStep !== firstStep && (
            <div className={classes.next}>
              <EllipseButton disabled={!formData.isCompleted} onClick={next}>{Strings.COMPLETED}</EllipseButton>
            </div>
          )} */}
          {stateData.currentStep !== firstStep &&
          <div className={classes.next}>
            <EllipseButton type="submit" disabled={formData?.assignedParkers?.length === 0} /*disabled={formData?.tokens?.length === 0}*/>{Strings.COMPLETED}</EllipseButton>
          </div>}
        </form>
      </div>
    </>
  );
};

export default AddAllocationsForm;
